import React, {useState} from "react";
import {Fade} from "react-reveal";
import "./ProjectIntro.scss";

export default function ProjectIntro() {
  const filters = ["All", "Web Design", "Branding", "Social Media", "Automation"];
  const portfolioItems = [
    {
      title: "Cumpas Hub",
      category: "Web Development",
      filter: "Web Design",
      image: require("../../assets/images/unimarket.png"),
      style: "real-image-card"
    },
    {
      title: "Analytics Tech",
      category: "Web Development",
      filter: "Web Design",
      image: require("../../assets/images/analytics.png"),
      style: "real-image-card"
    },
    {
      title: "Cogni Edge",
      category: "Web Development",
      filter: "Web Design",
      image: require("../../assets/images/cogni.png"),
      style: "real-image-card"
    },
    {
      title: "My Portifolio",
      category: "Web Development",
      filter: "Web Design",
      image: require("../../assets/images/porti.png"),
      style: "real-image-card"
    },
    {
      title: "Brand Concept 1",
      category: "Brand Identity",
      filter: "Branding",
      image: require("../../assets/images/brand1.png"),
      style: "real-image-card"
    },
    {
      title: "Brand Concept 2",
      category: "Brand Identity",
      filter: "Branding",
      image: require("../../assets/images/brand2.png"),
      style: "real-image-card"
    },
    {
      title: "Brand Concept 3",
      category: "Brand Identity",
      filter: "Branding",
      image: require("../../assets/images/brand3.png"),
      style: "real-image-card"
    },
    {
      title: "Social Media Campaign",
      category: "Social Media Management",
      filter: "Social Media",
      image: require("../../assets/images/social1.png"),
      style: "real-image-card"
    },
    {
      title: "WhatsApp Chatbot",
      category: "AI & Automation",
      filter: "Automation",
      image: require("../../assets/images/automation1.png"),
      style: "real-image-card"
    }
  ];
  const [activeFilter, setActiveFilter] = useState("All");
  const visibleItems =
    activeFilter === "All"
      ? portfolioItems
      : portfolioItems.filter(item => item.filter === activeFilter);

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="project-showcase-wrap">
        <section className="projects-intro-section" id="project-showcase">
          <div className="projects-intro-copy">
            <span className="projects-intro-word" aria-hidden="true">
              PROJECTS
            </span>
            <span className="projects-intro-mark" aria-hidden="true" />

            <div className="projects-intro-content">
              <h2>
                Some of my <span>realized</span>
                <br />
                and future projects
              </h2>
              <p>
                Here is a list of websites I either collaborated on, built
                and/or managed. Some were built under company work, while others
                came through freelance projects and product experiments.
              </p>
            </div>

            <span className="projects-intro-line" aria-hidden="true" />
            <a className="projects-intro-scroll" href="#portfolio-grid">
              Let's Start
              <span aria-hidden="true">&darr;</span>
            </a>
          </div>

          <div className="projects-intro-visual" aria-hidden="true">
            <div className="device desktop-device">
              <div className="device-screen"></div>
              <div className="desktop-neck"></div>
              <div className="desktop-base"></div>
            </div>
            <div className="device tablet-device">
              <div className="device-screen"></div>
            </div>
            <div className="device phone-device">
              <div className="device-screen"></div>
            </div>
            <div className="device laptop-device">
              <div className="device-screen"></div>
              <div className="laptop-base"></div>
            </div>
            <div className="projects-intro-pattern"></div>
          </div>
        </section>

        <section className="project-portfolio-section" id="portfolio-grid">
          <span className="portfolio-bg-title" aria-hidden="true">
            PORTFOLIO
          </span>
          <span className="portfolio-bg-slashes" aria-hidden="true">
            {"//"}
          </span>

          <div className="portfolio-filter-row">
            <div className="portfolio-filter-label">
              <span aria-hidden="true">&#9663;</span>
              Filter:
            </div>
            <div className="portfolio-filter-buttons">
              {filters.map(filter => (
                <button
                  className={activeFilter === filter ? "active-filter" : ""}
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  type="button"
                >
                  {filter}
                </button>
              ))}
            </div>
            <div className="portfolio-count">
              <span></span>
              {String(visibleItems.length).padStart(2, "0")} /{" "}
              <strong>{String(portfolioItems.length).padStart(2, "0")}</strong>
            </div>
          </div>

          <div className="portfolio-grid">
            {visibleItems.map(item => (
              <article
                className={`portfolio-card ${item.style}`}
                key={item.title}
              >
                <div className="portfolio-art">
                  {item.image ? (
                    <img src={item.image} alt={item.title} className="portfolio-real-image" />
                  ) : (
                    <>
                      <span className="portfolio-device one"></span>
                      <span className="portfolio-device two"></span>
                      <span className="portfolio-screen"></span>
                      <span className="portfolio-script">SoulFreakah</span>
                      <span className="portfolio-logo">{item.title}</span>
                    </>
                  )}
                </div>
                <div className="portfolio-hover">
                  <span className="portfolio-search" aria-hidden="true"></span>
                  <div className="portfolio-hover-panel">
                    <span className="portfolio-hover-line"></span>
                    <div>
                      <strong>{item.title}</strong>
                      <span>{item.category}</span>
                    </div>
                    <span
                      className="portfolio-hover-block"
                      aria-hidden="true"
                    ></span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </Fade>
  );
}
